import { render, staticRenderFns } from "./proofForm.vue?vue&type=template&id=71745b03&scoped=true"
import script from "./proofForm.vue?vue&type=script&lang=js"
export * from "./proofForm.vue?vue&type=script&lang=js"
import style0 from "./proofForm.vue?vue&type=style&index=0&id=71745b03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71745b03",
  null
  
)

export default component.exports